import React from "react";
import "./boxStyle.css";
import folderImg from "@/assets/img/folder.png";
import { assetUrl } from "@/utils/assetUrl";

/** A folder entry as the folder listing (or createFolder) returns it. */
export type MediaFolder = { name?: string; path?: string };

export type FolderProps = {
  folder?: MediaFolder;
  clickHandler?: (folder: MediaFolder) => void;
};

const Folder = ({
  folder = {},
  clickHandler = (_folder: MediaFolder) => {},
}: FolderProps) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    clickHandler(folder);
  };

  return (
    <div className="col-auto box" onClick={handleClick}>
      <img
        src={assetUrl(folderImg)}
        alt="folder"
      />
      <h4 className="text-center text-primary">{folder.name}</h4>
    </div>
  );
};

export default Folder;
